import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import PropTypes from 'prop-types';

const QueryRouter = ({ location = {}, command, path = '', children }) => {
  const params = qs.parse(location.search);
  const cmdParam = params.cmd;
  const pathParams = params.path || '/';
  let match = true;

  if (command) {
    match = params.cmd && cmdParam === command;
  }

  if (path) {
    match = match && pathParams === path;
  }

  return match ? children : null;
};

QueryRouter.propTypes = {
  location: PropTypes.object,
  command: PropTypes.string.isRequired,
  path: PropTypes.string,
};

export default withRouter(QueryRouter);
